import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfExperimentTableDto from '../dto/WhatIfExperimentTableDto';

class WhatIfExperimentTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfExperimentTableControl';
	}

	/**
	 * @param {number} whatIf
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<WhatIfExperimentTableDto>>}
	 */
	getList(whatIf, session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					whatIf,
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, WhatIfExperimentTableDto)))
				.catch(reject);
		});
	}
}

export default new WhatIfExperimentTableService();
